import Vue from 'vue'
import Router from 'vue-router'
import Home from 'pages/Home.vue'
import Announcement from 'pages/Announcement.vue'
import Login from 'pages/Login.vue'
// import Register from 'components/Home/registerPage.vue'
// import Sites from 'components/Sites.vue'
import Sites from 'pages/Sites.vue'
import Printers from 'pages/Printers.vue'
import PrintersStatus from 'pages/PrintersStatus.vue'
import TonerHistory from 'pages/TonerHistory.vue'
import Printer from 'pages/Printer.vue'
import PrinterHistory from 'pages/PrinterHistory.vue'
import History from 'pages/PrintHistory.vue'
import Inbox from 'pages/Inbox.vue'
import Reports from 'pages/Reports.vue'
import ReportEditor from 'pages/ReportEditorAdmin.vue'
import ReportDesigner from 'pages/ReportDesigner.vue'
import Dashboard from 'pages/Dashboard.vue'
import Counter from 'pages/Counter.vue'
import Dealers from 'pages/Dealers.vue'
import Dealer from 'pages/Dealer.vue'
import Customers from 'pages/Customers.vue'
import Users from 'pages/Users.vue'
import Alerts from 'pages/Alerts.vue'
// import Register from 'pages/Register.vue'
import Account from 'pages/Account.vue'
import Settings from 'pages/Settings.vue'
import Updates from 'pages/Updates.vue'
import Contactus from 'pages/Contactus.vue'
import Activity from 'pages/Activity.vue'

import PageNotFound from 'pages/PageNotFound.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Announcement',
      name: 'Announcement',
      component: Announcement
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Login
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Login
    },
    {
      path: '/Thanks',
      name: 'Thanks',
      component: Login
    },
    {
      path: '/Greeting',
      name: 'Greeting',
      component: Login
    },
    {
      // path: '/Verify/:VerifcationCode?',
      path: '/Verify',
      query: { Code: 'NA' },
      name: 'Verify',
      component: Login
    },
    /*
    {
      path: '/Download/:type?',
      name: 'Download',
      component: Login
    },
    */
    {
      path: '/Download/:type?',
      name: 'Login',
      component: Login
    },
    {
      path: '/Welcome',
      name: 'Welcome',
      component: Login
    },
    {
      path: '/Guide',
      name: 'Guide',
      component: Home,
      beforeEnter: (to, from, next) => {
        // alert(JSON.stringify(to))
        DownloadPDF()
        next(false)
      }
    },
    {
      path: '/Counter',
      name: 'Counter',
      component: Counter
    },
    {
      path: '/Dealers',
      name: 'Dealers',
      component: Dealers
    },
    {
      path: '/Dealer/:dealerKey',
      name: 'Dealer',
      component: Dealer
    },
    {
      path: '/Customers',
      name: 'Customers',
      component: Customers
    },
    {
      path: '/Users',
      name: 'Users',
      component: Users
    },
    {
      path: '/Alerts',
      name: 'Alerts',
      component: Alerts
    },
    {
      path: '/Printers/:customerKey/:siteKey/:statusFilter',
      name: 'Printers',
      component: Printers
    },
    {
      path: '/PrintersStatus/:customerKey/:siteKey',
      name: 'PrintersStatus',
      component: PrintersStatus
    },
    {
      path: '/TonerHistory/:customerKey/:siteKey',
      name: 'TonerHistory',
      component: TonerHistory
    },
    {
      path: '/Printer/:printerKey',
      name: 'Printer',
      component: Printer
    },
    {
      path: '/PrinterHistory/:printerKey',
      name: 'PrinterHistory',
      component: PrinterHistory
    },
    {
      path: '/History/:customerKey/:siteKey',
      name: 'History',
      component: History
    },
    {
      path: '/Inbox',
      name: 'Inbox',
      component: Inbox
    },
    {
      path: '/Sites/:customerKey',
      name: 'Sites',
      component: Sites
    },
    {
      path: '/Reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/ReportEditor',
      name: 'ReportEditor',
      component: ReportEditor
    },
    {
      path: '/ReportDesigner/:reportKey',
      name: 'ReportDesigner',
      component: ReportDesigner
    },
    {
      path: '/Account',
      name: 'Account',
      component: Account
    },
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/Updates',
      name: 'Updates',
      component: Updates
    },
    {
      path: '/Activity',
      name: 'Activity',
      component: Activity
    },
    {
      // path: "*",
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: PageNotFound,
      meta: {
        requiresAuth: false
      }
    }
  ],
  linkActiveClass: 'active'
})

function DownloadPDF () {
  // alert('Lets download PDF... ')
  var hiddenElement = document.createElement('a')
  hiddenElement.href = 'https://firebasestorage.googleapis.com/v0/b/b-info.appspot.com/o/Documentation%2FPrinter%20Counters%20Installation%20Guide.pdf?alt=media&token=6626d737-95d1-4c1f-8642-cf6ff809c2c3'
  hiddenElement.target = '_blank'
  hiddenElement.download = 'Printer Counters Installation Guide.pdf'
  hiddenElement.click()
}



// WEBPACK FOOTER //
// ./src/router/index.js